var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 1.152a.717.717 0 0 1 1.013-.048l1.61 1.466a.018.018 0 0 1 0 .025 1.743 1.743 0 0 0 .126 2.462 1.743 1.743 0 0 0 2.463-.104.019.019 0 0 1 .026-.001l1.61 1.465a.718.718 0 0 1 .047 1.014l-4.83 5.303-.385-.35a.36.36 0 0 0-.483.53l.385.35-5.41 5.941a.717.717 0 0 1-1.013.047l-1.098-1c-.29-.265-.295-.715-.173-1.089a1.753 1.753 0 0 0-.49-1.838 1.753 1.753 0 0 0-1.875-.316c-.361.156-.81.194-1.1-.07l-1.098-1a.717.717 0 0 1-.048-1.013l5.41-5.94.384.35a.359.359 0 0 0 .483-.53l-.384-.35 4.83-5.304Zm-.577 9.662a.358.358 0 0 0 .023.506l.876.797a.358.358 0 0 0 .483-.53l-.875-.797a.36.36 0 0 0-.507.024ZM9.473 9.22a.358.358 0 0 0 .023.507l.875.797a.358.358 0 0 0 .484-.531l-.875-.797a.359.359 0 0 0-.507.024Zm-1.75-1.594a.358.358 0 0 0 .023.507l.875.797a.358.358 0 0 0 .484-.531l-.876-.797a.359.359 0 0 0-.507.024Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.054,
    y1: 13.875,
    x2: 17.172,
    y2: 18.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon2);
export default __webpack_public_path__ + "static/media/voucher-icon-2.46774287b8c0bb704a168e9e5c2ae140.svg";
export { ForwardRef as ReactComponent };